import * as ContextMenu from '@studio/design-system/context-menu';
import { χref } from '@studio/react-utils/hooks';
import { dequal } from 'dequal/lite';
import { memo, useRef } from 'react';
import type { ReactElement } from 'react';
import { Menu } from './menu.jsx';
import type { Props } from './types.js';
import { Card } from '#~/audio/components/card/index.js';
import type { Behavior } from '#~/common/card/index.js';

/** @internal */
const Inner = ({ device, handler, ...props }: Props): ReactElement => {
  const cardRef = useRef<Behavior>(null);

  const menuHandler = {
    onRemove(): void {
      handler.onRemove(device.id);
    },

    onRename(): void {
      window.setTimeout(() => {
        χref(cardRef)?.setEditing(true);
      }, 250);
    },

    onSettings(): void {
      handler.onSettings(device.id);
    }
  };

  return (
    <ContextMenu.Root>
      <ContextMenu.Trigger>
        <Card device={device} handler={handler} ref={cardRef} {...props} />
      </ContextMenu.Trigger>

      <Menu handler={menuHandler} />
    </ContextMenu.Root>
  );
};

/** Audio source `<Item>`. */
export const Item = memo(Inner, dequal);
